export const ControlStatusesConfig = {
  getDatasetData: '/dataset/v2/getDatasetData?datasetId={:datasetId}&dataProviderId={:dataProviderId}',
  deleteDatasetData: '/dataset/v2/truncateDataset?datasetId={:datasetId}'
};
